import { render } from "./SystemMessageDetail.vue?vue&type=template&id=3d373364&scoped=true"
import script from "./SystemMessageDetail.vue?vue&type=script&lang=js"
export * from "./SystemMessageDetail.vue?vue&type=script&lang=js"

import "./SystemMessageDetail.vue?vue&type=style&index=0&id=3d373364&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d373364"],['__file',"src/views/h5/common/sys/systemMessage/SystemMessageDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d373364"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d373364', __exports__)) {
    api.reload('3d373364', __exports__)
  }
  
  module.hot.accept("./SystemMessageDetail.vue?vue&type=template&id=3d373364&scoped=true", () => {
    api.rerender('3d373364', render)
  })

}


export default __exports__